/**
 * Lomi impact numbers — STATIC, hand-frozen from production.
 *
 * Deliberately static (not a live /public/impact fetch): this is a marketing /
 * investor / parent surface where a fast, stable, guaranteed-non-zero number
 * beats a live query that can fl/ show seed data / lag. Refresh by re-running
 * the prod snapshot and bumping AS_OF.
 *
 * Snapshot source: prod DB (52.2.104.156), non-test, non-merged students.
 * Everything here is reach / volume / engagement + the one honest efficacy
 * proxy (spaced-review recovery). We never claim exam-score improvement.
 */

export const AS_OF = 'July 2026';

export const LOMI_STATS = {
  students: 24507,
  telegramStudents: 16787,   // 68% of students reached via the Telegram bot
  weeklyActive: 5960,
  everPractised: 18021,
  questionsAnswered: 1931127,
  questionsCorrect: 1207906,
  aiConversations: 39409,
  aiMessages: 359076,
  assessmentSessions: 254500,
  schools: 3655,
  testimonialsPublished: 166,
  subjects: 10,
  // Spaced-review recovery: of questions first answered wrong then re-seen >=20h
  // later, this fraction flipped to correct. Clock-skew-immune (app timestamps).
  recovery: {
    retries: 103620,
    recovered: 55918,
    pct: 54,
  },
} as const;

/**
 * Exam coverage. ESSLCE is LIVE. Everything else is roadmap — NOT built yet,
 * and must always render as clearly-future ("Coming"), never as available.
 */
export type ExamStatus = 'live' | 'coming';
export const LOMI_EXAMS: { name: string; short: string; grade: string; status: ExamStatus }[] = [
  { name: 'ESSLCE', short: 'ESSLCE', grade: 'Grade 12 · University entrance', status: 'live' },
  { name: 'Remedial exam', short: 'Remedial', grade: 'University remedial', status: 'coming' },
  { name: 'University Exit Exam', short: 'Exit Exam', grade: 'Undergraduate exit', status: 'coming' },
  { name: 'Grade 8 National Exam', short: 'Grade 8', grade: 'Primary national', status: 'coming' },
];
